// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	FeeSubjectToHstCheckbox: 'fee-subject-to-hst-checkbox',
	RequireSecondaryIdCheckbox: 'require-secondary-id-checkbox',
	RequireFinancialInstitutionLoginCheckbox:
		'require-financial-institution-login-checkbox',
	RequireAdvancedAmlScreeningCheckbox:
		'require-advanced-aml-screening-checkbox',
	//	MyHookName: 'myHookIdentifier',
} as const;
